module.exports = __webpack_public_path__ + "img/santa-marta.0a5f5df4.jpg";